import pick from 'lodash/pick';
import { useCommonStore } from "~/stores";

// ✅ Các key có tên giống nhau giữa store.data và return value
const COMMON_KEYS = [
  'periodDate',
  'period_name',
  'lifeProviders',
  'noneLifeProviders',
  'provinceId',
  'districtId',
  'wardId',
  'lifeSubProducts',
  'choiceList',
  'currentProviderId',
  'productMainId',
  'provinceList',
  'wardList',
  'lifeTypes',
  'lifeStatus',
  'selectedFormId',
  'commissionTypes',
  'periodList',
  'hideNotification',
  'listBank',
  'agentLevels',
  'agentStatusList',
  'agentStatusSelected',
  'agentLevelSelected',
  'periodDicList',
  'permissionList',
  'provinceIssuedList',
  'outcomeList',
  'incomeList',
  'formIds',
  'documentTypes',
  'listFeeTypes',
  'listFinan',
  'lifeInsuranceData',
  'incomeParentList',
  'outcomeParentList',
  'abroadProvider',
  'productList',
  'providerList',
  'subProviders',
  'subOrders',
  'userPackage',
] as const;

export const useCommon = (key?: string) => {
  return useCommonStore((state) => {
    const dataObj = state.data || {};
    return {
      data: key ? dataObj[key as keyof typeof dataObj] : undefined,
      // ✅ Tất cả same-name keys gom trong 1 pick
      ...pick(dataObj, COMMON_KEYS),
      // 🔀 2 key có tên khác nhau giữa store và return
      currentSecretkey: dataObj.currentSecretKey,
      reportList: dataObj.reportingPeriod,
    };
  });
};
